<div class="d-flex justify-content-center mt-2">

    <div (click)="openUpdateModal()"
        *ngIf="viewEdit()"
        style="cursor: pointer;">
        <div class="d-flex align-items-center " >
            <i class="fa-solid fa-pen-to-square" title="Edit"></i>
        </div>
    </div>

    <div (click)="openDeleteModal()"
        *ngIf="viewDelete()"
        style="cursor: pointer; margin-left: 20%;">
        <div class="d-flex align-items-center ">
            <i class="far fa-trash-alt" title="Delete"></i>
        </div>
    </div>

</div>